import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController, ToastController, Platform } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { WireTransferService } from 'src/app/angular-wallet-base/services/wire-transfer.service';
import { getWireDetails, WireDetails } from 'src/app/angular-wallet-base/wire-details';
import { TranslateService } from '@ngx-translate/core';
import {
  ozToGramsNew,
  getToastPosition,
  calculateLode,
  removeSpecialChars,
  setUnit,
  presentToast,
  handleCopy,
  getTokenInfoArray,
} from '../../../angular-wallet-base/utils';
import { LaravelResponse, MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { CryptoTransferService } from 'src/app/angular-wallet-base/services/crypto-transfer.service';
import { SwapWarningModalComponent } from '../swap-caution-modal/swap-warning.modal';
import { PinModalComponent } from 'src/app/components/pin-modal/pin-modal.component';
import { ASSET_FEE_METALS_PERCENTAGE, AUTH_REASON, convertStringToTokenType, Metal, PAYWITH, TokenType, Unit } from 'src/app/angular-wallet-base/constants';
import { SimplexCheckoutModalComponent } from '../simplex-checkout/simplex-checkout';
import { CreditDebitCardService } from 'src/app/angular-wallet-base/services/debit-credit-card.service';
import { BuildInfo } from '@awesome-cordova-plugins/build-info/ngx';
import { SimplexPaymentConfirmationModalComponent } from '../simplex-payment-confirmation/payment-confirmation-modal';
import { ClipboardService } from 'ngx-clipboard';
import { Clipboard } from '@ionic-native/clipboard/ngx';

import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { getKeychain } from 'src/app/angular-wallet-base/store/wallet';
import { take } from 'rxjs/operators';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { BankAccountService } from 'src/app/angular-wallet-base/services/bank-account.service';
import { GetAllTokenBalancesAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { GetBankAccountBalanceRequest } from 'src/app/angular-wallet-base/actions/bankAccount.actions';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
interface QrCodeData {
  isTokenAmountChange: boolean;
  address?: string;
  payWith?: string;
  orderTotal?: string;
  quoteId?: string;
  reviewOrderDetails?: ReviewOrderDetails;
}
interface ReviewOrderDetails {
  amount: string;
  amountOld: string;
  amountFiat: string;
  amountFiatOld: string;
  amountFiatDisplay: string;
  amountFiatDisplayOld: string;
  swap_amount_fiat_display: string;
  swap_amount_fiat: string;
  amountCrypto: string;
  amountCryptoOld: string;
  amount_to_swap: string;
  asset: string;
  currencyCode: string;
  fiatCurrencyCode: string;
  currencySymbol: string;
  payWith: string;
  payWithDisplay: string;
  promo: string;
  token_fiat_value: string;
  swap_token_fiat_value: string;
  token_fiat_value_old: string;
  feeAmount: string;
  feeAmount_old: string;
  discount: string;
  totalSilver: number;
  totalGold: number;
  oneLodeSilver: number;
  oneLodeGold: number;
  cart: [];
  isTokenAmountChange: boolean;
  quoteId?: string;
  isNewUser: boolean;
  bonus: number;
  slippageTolerance: number;
  priceImpact: any;
  minimumAmount: any;
  swappingPair: string;
  routeSwapPair1: string;
  routeSwapPair2: string;
  isNormalSwap: boolean;
  feeAmount2: string;
  paymentId?: string;
  swapNetwork?: string;
  tokenFrom?: string;
  destinationWalletAddress?: string;
  fiat_to_token: boolean;
  primeRate?: string;
}
interface CardOrder {
  grams: number;
  oz: number;
  metal_type: 'gold' | 'silver';
  user_message: string;
  equivalentgramsofgoldinsilver: number | void;
}
@Component({
  selector: 'review-order',
  templateUrl: './review-order.component.html',
  styleUrls: ['./review-order.component.scss'],
})
export class ReviewOrderComponent implements OnInit {
  public reviewOrderDetails: ReviewOrderDetails;
  isDesktopMode;
  loadingDelivery: boolean;
  disableDeliveryBtn: boolean;
  promoCode: string = '';
  promoErrorMessage: string;
  promoCodeError: boolean;
  loaderActivepromo: boolean;
  public quoteId;
  public wireDetail: WireDetails;
  public cart: any = [];
  public totalTokenAmount = 0;
  public equivalentGramsToGold = 0;
  public totalGramsOfMetals = 0;
  public itemArr = [];
  public lodeRateGrams;
  public publicInfo;
  public oneLodeGold: number;
  public oneLodeSilver: number;
  public confirmedResponse: QrCodeData = { address: '', orderTotal: '', payWith: '', isTokenAmountChange: false };
  public hidePayWith: boolean;
  public bip21str;
  public reviewStatusForMetal: any;
  private walletAddress: string;
  private avaxSwapPayload = null;
  newMember: boolean;
  newMemberOfferData: any;
  swapTokens = ['eth', 'btc', 'aux', 'agx', 'sol', 'usdc','usdt', 'avax', 'lode', 'usd'];
  tokens;
  public slippageTolerance;
  orderMetalRes: any;
  public appVersion;
  public InstalledDate;
  public walletType;
  public primeError: boolean = false;
  public primeErrorMessage: string = '';
  public showSpinner = false;
  public transactionFee = ASSET_FEE_METALS_PERCENTAGE;
  public transactionFeeAmount: string;

  constructor(
    public appMode: AppModeService,
    protected store: Store<AppState>,
    private membersPortalService: MembersPortalService,
    private nav: NavController,
    private route: ActivatedRoute,
    private wireTransferService: WireTransferService,
    private translate: TranslateService,
    private toast: ToastController,
    private platform: Platform,
    private alertController: AlertController,
    private cryptoTransferService: CryptoTransferService,
    private modalController: ModalController,
    private creditDebitCardService: CreditDebitCardService,
    private buildInfo: BuildInfo,
    private clipboard: Clipboard,
    private clipboardService: ClipboardService,

    private oneInchService: OneInchService,
    private walletService: WalletService,
    private bankAccount: BankAccountService
  ) {
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  async ngOnInit() {
    this.platform.ready().then(() => {
      this.buildInfo.version = this.appVersion;
      this.buildInfo.installDate = this.InstalledDate;
    });
    this.walletType = this.walletService.getWalletType();

    this.publicInfo = await this.membersPortalService.getPublicInfo();
    // this.lodeRateGrams = this.publicInfo.data.lode_rate;
    this.route.queryParams.subscribe(async (params) => {
      this.reviewOrderDetails = JSON.parse(await params.form);
      Logger.info('review order details', this.reviewOrderDetails);
      this.slippageTolerance = removeSpecialChars(this.reviewOrderDetails.slippageTolerance) + '%';
      this.hidePayWith = this.swapTokens.includes(this.reviewOrderDetails.payWith) ? true : false;
      this.cart = this.reviewOrderDetails.cart;
        let keyChain = await this.store.select(getKeychain).pipe(take(1)).toPromise();
        this.walletAddress = keyChain.AVAX.address;
      if (this.cart.length !== 0) {
        this.calculateCart();
      }
      if (this.reviewOrderDetails.promo) {
        this.promoCode = this.reviewOrderDetails.promo;
        this.newMember = this.reviewOrderDetails.isNewUser;
        if (this.reviewOrderDetails.isNewUser) {
          this.togglePromoCode();
        }
      }
      if (this.reviewOrderDetails?.destinationWalletAddress) {
        this.walletAddress = this.reviewOrderDetails.destinationWalletAddress;
      }
      if((this.reviewOrderDetails?.asset === 'AUX' || this.reviewOrderDetails?.asset === 'AGX')&& ['btc', 'usdc', 'usdt'].includes(this.reviewOrderDetails?.currencyCode)) {
        this.walletAddress = keyChain.AVAX.address;
      } else  if (this.reviewOrderDetails?.swapNetwork === 'AVAX') {
        this.walletAddress = keyChain.AVAX.address;
        this.avaxSwapPayload = null;
      } else if (this.reviewOrderDetails?.swapNetwork === 'BTC') {
        this.walletAddress = keyChain.BTC.address;
      } else if (this.reviewOrderDetails?.swapNetwork === 'ETH') {
        this.walletAddress = keyChain.ETH.address;
      } else if (this.reviewOrderDetails?.swapNetwork === 'USDC' || this.reviewOrderDetails?.swapNetwork === 'USDT') {
        this.walletAddress = keyChain.ETH.address;
      } else if(this.reviewOrderDetails.payWith == 'eth') {
        this.walletAddress = keyChain.AVAX.address;
      }
      this.hidePayWith = this.reviewOrderDetails.payWith == 'usdt' || this.reviewOrderDetails.payWith == 'usdc' || this.reviewOrderDetails.payWith == 'eth' || this.reviewOrderDetails.payWith == 'btc' ? true : false;
    });
  }

  setCurrencyCode() {
    if (this.swapTokens.includes(this.reviewOrderDetails.payWith)) {
      return this.reviewOrderDetails.currencyCode;
    } else {
      return this.reviewOrderDetails.fiatCurrencyCode;
    }
  }

  async onSubmit() {
    this.loadingDelivery = true;
    this.disableDeliveryBtn = true;
    const code = this.reviewOrderDetails.promo;
    console.log('========================================')
    console.log(this.reviewOrderDetails.payWith)
    console.log('========================================')

    switch (this.reviewOrderDetails.payWith) {
      case PAYWITH.BankTransfer:
        await this.submitBankTransferOrder(code);
        break;
      case PAYWITH.MyMetals:
        await this.submitMetalOrder();
        break;
      case PAYWITH.Silver_Card:
        if (this.reviewOrderDetails.paymentId) {
          this.opensimplex();
        } else {
          await this.paymentRequest();
        }
        break;
      case PAYWITH.ETH:
        await this.submitCryptoOrder();
        break;
       case PAYWITH.USDC:
        await this.submitCryptoOrder();
        break;
      case PAYWITH.USDT:
        await this.submitCryptoOrder();
        break
      case PAYWITH.BTC:
        await this.submitCryptoOrder();
        break;
        case PAYWITH.USDBalance:
        await this.submitForm();
        break;
      default:
        break;
    }
  }

  goToSuccess(txHash?: string) {
    this.nav.navigateForward(['/buy-assets/success'], {
      queryParams: {
        successOrderDetails: JSON.stringify(this.reviewOrderDetails),
        txHash,
      },
    });
  }

  goBack() {
    this.nav.navigateBack(['/buy-assets', this.reviewOrderDetails.asset], {
      queryParams: { form: JSON.stringify(this.reviewOrderDetails) },
    });
  }

  isPromoCodeDisabled() {
    if (this.reviewOrderDetails.isNewUser || (this.reviewOrderDetails.promo && this.promoCode)) {
      return true;
    } else {
      return !this.promoCode.trim();
    }
  }

  removePromo() {
    if (this.reviewOrderDetails.payWith === PAYWITH.BankTransfer) {
      this.validatePromoCodeForBankTransfer();
    } else if (this.reviewOrderDetails.payWith === PAYWITH.ETH || this.reviewOrderDetails.payWith === PAYWITH.BTC) {
      this.validatePromoCodeForPayByCrypto();
    } else if (this.reviewOrderDetails.payWith === PAYWITH.MyMetals) {
      this.reviewOrderDetails.bonus = null;
      this.reviewOrderDetails.promo = '';
      let beforeToken = parseInt(this.orderMetalRes.data.quote.totalTokensBeforePromo);
      this.reviewOrderDetails.amount = beforeToken.toFixed(2);
    }
  }

  togglePromoCode() {
    this.loaderActivepromo = true;
    if (this.reviewOrderDetails.payWith === PAYWITH.BankTransfer) {
      this.validatePromoCodeForBankTransfer();
    } else if (this.reviewOrderDetails.payWith === PAYWITH.ETH || this.reviewOrderDetails.payWith === PAYWITH.BTC) {
      this.validatePromoCodeForPayByCrypto();
    } else if (this.reviewOrderDetails.payWith === PAYWITH.MyMetals) {
      this.validatePromoCodeForMetal();
    }
  }

  async submitMetalOrder() {
    this.loadingDelivery = true;
    this.disableDeliveryBtn = true;
    this.reviewStatusForMetal = 0;
    const data: any = await this.membersPortalService.createBullionOrder(
      this.itemArr,
      this.reviewStatusForMetal,
      this.reviewOrderDetails.promo,
      null
    );
    Logger.info(data);

    if (!data || data.status === 0 || data.error) {
      this.loadingDelivery = false;
      if (data.error.error_code == 'validation_error') {
        await presentToast('Failed', data.error.message, this.translate, this.toast, this.platform, true);
      } else {
        await presentToast('Failed', 'Please try again later', this.translate, this.toast, this.platform, true);
      }
      return;
    }
    // Reset form and cart
    this.cart = '';
    this.loadingDelivery = false;
    this.goToSuccess();
  }

  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000,
    });
    await toast.present();
  }

  async showAlertConfirmation(title, msg) {
    const alert = await this.alertController.create({
      header: await this.translate.get(title).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      buttons: ['OK'],
    });
    return await alert.present();
  }

  validatePromoError() {
    if (this.promoCodeError) {
      return true;
    }
    return false;
  }

  // my metals opeartions
  convertGoldGramsInSilver(val) {
    return val * this.publicInfo.data.gold_silver_ratio;
  }

  async calculateCart() {
    this.showSpinner = true;
    let calGoldQul = 0;
    let calSilverQul = 0;
    let amount = 0;

    this.itemArr = [];
    this.reviewOrderDetails.totalGold = 0;
    this.reviewOrderDetails.totalSilver = 0;
    this.equivalentGramsToGold = 0;
    this.reviewOrderDetails.oneLodeGold = 0;
    this.reviewOrderDetails.oneLodeSilver = 0;
    this.totalTokenAmount = 0;
    if (this.cart?.length) {
      this.itemArr = await Promise.all(this.cart.map(async (item): Promise<CardOrder> => {
        const totalWeight = parseFloat(item.qty) * parseFloat(item.weight);
        const weight = isNaN(parseFloat(item.weight)) ? 0 : parseFloat(item.weight);
        const qty = isNaN(parseFloat(item.qty)) ? 0 : parseFloat(item.qty);
        const tokenType = convertStringToTokenType(this.reviewOrderDetails.asset);
        let tokenAmount;
        try {
          tokenAmount = await this.getTokenRate(tokenType, totalWeight, item.type);
        } catch (err) {
          this.showSpinner = false;
          Logger.error('Error in getting asset rate', err);
          return;
        }
        this.totalTokenAmount = this.totalTokenAmount + tokenAmount;
        if (item.type == 'gold') {
          calGoldQul = parseFloat(item.weight) * parseFloat(item.qty);
          this.reviewOrderDetails.totalGold = this.reviewOrderDetails.totalGold + calGoldQul;
          this.equivalentGramsToGold = this.equivalentGramsToGold + this.convertGoldGramsInSilver(ozToGramsNew(totalWeight));
          this.reviewOrderDetails.oneLodeGold = this.reviewOrderDetails.totalGold / parseFloat(this.totalTokenAmount.toFixed(2));
        }
        if (item.type == 'silver') {
          calSilverQul = parseFloat(item.weight) * parseFloat(item.qty);
          this.reviewOrderDetails.totalSilver = this.reviewOrderDetails.totalSilver + calSilverQul;
          this.equivalentGramsToGold = this.equivalentGramsToGold + ozToGramsNew(totalWeight);
          this.reviewOrderDetails.oneLodeSilver = this.reviewOrderDetails.totalSilver / parseFloat(this.totalTokenAmount.toFixed(2));
        }
        return {
          grams: ozToGramsNew(totalWeight),
          oz: totalWeight,
          metal_type: item.type,
          user_message: item.notes,
          equivalentgramsofgoldinsilver: item.type == 'gold' ? this.convertGoldGramsInSilver(ozToGramsNew(totalWeight)) : 0
        };
      }));
    }
    this.reviewOrderDetails.amount = this.calculateWithFee(this.totalTokenAmount, this.transactionFee).toFixed(2);
    this.transactionFeeAmount = this.getTransactionFeeAmount(this.totalTokenAmount, this.transactionFee).toFixed(2);
    this.showSpinner = false;
    this.reviewOrderDetails.cart = this.cart;
    this.disableDeliveryBtn = this.equivalentGramsToGold < 3110 ? true : false;
    if (this.newMember) {
      this.validatePromoCodeForMetal();
    }
  }

  calculateWithFee(amount: number, transactionFeePercentage: number): number {
    //given this.fee is representing a percentage, subtract this fee from the amount
    return (amount - this.getTransactionFeeAmount(amount, transactionFeePercentage));
  }

  getTransactionFeeAmount(amount: number, transactionFeePercentage: number): number {
    return amount * (transactionFeePercentage / 100);
  }
  /**
   * Get the rate of a token.
   * @returns 
   */
   async getTokenRate(token: TokenType, ozTotal: number, metal: Metal): Promise<number> {
    const response: LaravelResponse = await this.membersPortalService.getEquivalentTokenAmountFromWeight(token, Unit.TROY_OUNCE, ozTotal, metal);
    return response?.data;
  }

  handleCartData(val) {
    this.cart = val;
    // this.calculateLodeValue();
    this.calculateCart();
  }

  // bank transfer operations
  async validatePromoCodeForBankTransfer() {
    let quote: any;
    this.promoCodeError = false;
    try {
      Logger.info(this.promoCode);

      quote = await this.wireTransferService.getPriceQuoteTransaction(
        this.reviewOrderDetails.isTokenAmountChange
          ? this.reviewOrderDetails.amountOld
            ? this.reviewOrderDetails.amountOld
            : this.reviewOrderDetails.amount
          : this.reviewOrderDetails.amountFiatOld
            ? this.reviewOrderDetails.amountFiatOld
            : this.reviewOrderDetails.amountFiat,
        this.promoCode,
        '1',
        this.reviewOrderDetails.fiatCurrencyCode,
        this.reviewOrderDetails.asset,
        this.reviewOrderDetails.isTokenAmountChange
      );
      Logger.info(quote);
      this.loaderActivepromo = false;
      if (quote) {
        this.reviewOrderDetails.token_fiat_value = quote.data.ppt;
        this.reviewOrderDetails.token_fiat_value_old = quote.data.ppt_before_discount;
        this.reviewOrderDetails.amountFiatDisplay = this.reviewOrderDetails.currencySymbol + quote.data.price_total;
        this.reviewOrderDetails.amountFiatDisplayOld = this.reviewOrderDetails.currencySymbol + quote.data.price_total_before_discount;
        this.reviewOrderDetails.amountFiat = quote.data.price_total;
        this.reviewOrderDetails.amountFiatOld = quote.data.price_total_before_discount;
        this.reviewOrderDetails.amount = quote.data.qty.toFixed(2);
        this.reviewOrderDetails.amountOld = quote.data.qty_before_discount
          ? quote.data.qty_before_discount.toFixed(2)
          : quote.data.qty.toFixed(2);
        if (quote.data.promo_code) {
          this.promoCode = '';
          this.reviewOrderDetails.promo = quote.data.promo_code;
          this.reviewOrderDetails.discount = this.reviewOrderDetails.currencySymbol + quote.data.discount.toFixed(5);
          this.reviewOrderDetails.bonus = parseInt(quote.data.bonus_tokens);
        } else {
          this.promoCode = '';
          this.reviewOrderDetails.promo = null;
          this.reviewOrderDetails.discount = null;
          this.reviewOrderDetails.bonus = null;
        }
      }
    } catch (err) {
      if (err.error.error) {
        this.promoCodeError = true;
        let errorMessage = err.error.error;
        if (errorMessage.includes('promo_code_not_found')) {
          errorMessage = await this.translate.get('buy_agx.billing_form.promocode.invalid').toPromise();
        }
        this.promoErrorMessage = errorMessage;
        this.loaderActivepromo = false;
      }
      return;
    }
  }

  async submitBankTransferOrder(code?: string) {
    const quote: any = await this.wireTransferService.getPriceQuoteTransaction(
      this.reviewOrderDetails.isTokenAmountChange ? this.reviewOrderDetails.amount : this.reviewOrderDetails.amountFiat,
      code,
      '0',
      this.reviewOrderDetails.fiatCurrencyCode,
      this.reviewOrderDetails.asset,
      this.reviewOrderDetails.isTokenAmountChange
    );
    const quoteId = quote.data.quote_id;
    await this.wireTransferService.confirmTransaction(quoteId, this.walletAddress);
    this.quoteId = quoteId;
    this.wireDetail = getWireDetails(this.reviewOrderDetails.currencyCode);
    if (quoteId) {
      this.loadingDelivery = false;
      this.goToSuccess();
    } else {
      this.loadingDelivery = false;
    }
  }

  async submitForm() {
    // this.onMoveFunds.emit(this.form.value);
    this.loadingDelivery = true;
    this.primeError = false;
    if (this.reviewOrderDetails.asset === 'USD') {
      this.reviewOrderDetails.asset = this.reviewOrderDetails.payWith.toUpperCase();
    }
    const token = this.reviewOrderDetails.asset === 'AUX' ? 'aux' : this.reviewOrderDetails.asset === 'AGX' ? 'agx' : 'lode';
    try {
      let response;
      if (this.reviewOrderDetails.fiat_to_token) {
        response = await this.bankAccount.exchangeFiatToToken({
          token,
          tokenAmount: this.reviewOrderDetails.amount,
          fiatAmount: removeSpecialChars(this.reviewOrderDetails.amountFiatDisplay),
        });
        Logger.info(response);
      } else {
        response = await this.bankAccount.exchangeTokenToFiat({
          fiatAmount: removeSpecialChars(this.reviewOrderDetails.amountFiatDisplay),
          tokenAmount: this.reviewOrderDetails.amount,
          token,
        });
      }
      if (response?.status !== 200 && response?.errors) {
        this.primeError = true;
        this.primeErrorMessage = response.errors;
        return;
      }
    } catch (err) {
      // this.onError.emit(err);
      this.loadingDelivery = false;
      this.primeError = true;
      Logger.info(err);
      return;
    }

    // this.exchangeCompleted = true;
    this.loadingDelivery = false;
    this.store.dispatch(new GetAllTokenBalancesAction());
    this.store.dispatch(new GetBankAccountBalanceRequest());
    this.goToSuccess();

    // this.onComplete.emit(this.form.value);
  }

  // metal operations//
  async validatePromoCodeForMetal() {
    this.reviewStatusForMetal = 1;
    this.promoCodeError = false;
    this.orderMetalRes = await this.membersPortalService.createBullionOrder(this.itemArr, this.reviewStatusForMetal, this.promoCode, null);
    if (this.orderMetalRes.data && this.orderMetalRes.status !== 0) {
      const amt = parseInt(this.orderMetalRes.data.quote.totalTokensAfterPromo);
      this.reviewOrderDetails.amount = amt.toFixed(2);
      this.loaderActivepromo = false;
      if (this.orderMetalRes.data.promoDetails) {
        this.promoCode = '';
        this.reviewOrderDetails.bonus = parseInt(this.orderMetalRes.data.quote.bonusTokens);
        this.reviewOrderDetails.promo = this.orderMetalRes.data.promoDetails.code;
      } else {
        this.promoCode = '';
        this.reviewOrderDetails.promo = null;
      }
    } else {
      this.loaderActivepromo = false;
      const errorMessage = this.orderMetalRes.status == 0 ? this.orderMetalRes.message : 'The Promo Code is invalid.';
      this.promoErrorMessage = errorMessage;
      this.promoCodeError = true;
    }
  }

  // crypto operations//
  async validatePromoCodeForPayByCrypto() {
    let quote: any;
    this.promoCodeError = false;
    try {
      quote = await this.cryptoTransferService.getPriceQuoteTransaction(
        this.reviewOrderDetails.isTokenAmountChange ? this.reviewOrderDetails.amount : this.reviewOrderDetails.amountFiat,
        this.reviewOrderDetails.payWith,
        this.promoCode,
        '0',
        this.reviewOrderDetails.fiatCurrencyCode,
        this.reviewOrderDetails.asset,
        this.reviewOrderDetails.isTokenAmountChange
      );
      Logger.info(quote);
      this.loaderActivepromo = false;
      if (quote) {
        this.reviewOrderDetails.amountCrypto = parseFloat(quote.data.price_total).toFixed(4);
        this.reviewOrderDetails.amountCryptoOld = parseFloat(quote.data.price_total_before_discount).toFixed(4);
        this.reviewOrderDetails.token_fiat_value = quote.data.usd_price_per_token;
        this.reviewOrderDetails.amountFiatDisplay =
          this.reviewOrderDetails.currencySymbol + parseFloat(quote.data.usd_price_total).toFixed(2);
        this.reviewOrderDetails.amountFiatDisplayOld =
          this.reviewOrderDetails.currencySymbol + parseFloat(quote.data.usd_price_total).toFixed(2);
        this.reviewOrderDetails.amountFiat = parseFloat(quote.data.usd_price_total).toFixed(2);
        this.reviewOrderDetails.amountFiatOld = parseFloat(quote.data.usd_price_total).toFixed(2);
        this.reviewOrderDetails.amount = parseFloat(quote.data.qty).toFixed(2);
        this.reviewOrderDetails.amountOld = parseFloat(
          quote.data.qty_before_discount ? quote.data.qty_before_discount : quote.data.qty
        ).toFixed(2);
        this.reviewOrderDetails.quoteId = quote.data.quote_id;
        if (quote.data.promo_code) {
          this.promoCode = '';
          this.reviewOrderDetails.promo = quote.data.promo_code;
          this.reviewOrderDetails.discount = quote.data.discount.toFixed(5);
        } else {
          this.promoCode = '';
          this.reviewOrderDetails.promo = null;
          this.reviewOrderDetails.discount = null;
        }
      }
    } catch (err) {
      Logger.info(err);
      if (err.error.error) {
        this.promoCodeError = true;
        let errorMessage = err.error.error;
        if (errorMessage.includes('promo_code_not_found')) {
          errorMessage = await this.translate.get('buy_agx.billing_form.promocode.invalid').toPromise();
        }
        this.promoErrorMessage = errorMessage;
        this.loaderActivepromo = false;
      }
      return;
    }
  }

  async submitCryptoOrder() {
    this.quoteId = this.reviewOrderDetails.quoteId;
    //  Logger.info("quote ",quote);
    const response: any = await this.cryptoTransferService.confirmTransaction(this.quoteId, this.walletAddress);
    Logger.info('response ', response);
    if (response.data) {
      this.confirmedResponse.payWith = this.reviewOrderDetails.payWith;
      this.confirmedResponse.reviewOrderDetails = this.reviewOrderDetails;
      this.confirmedResponse.orderTotal = this.reviewOrderDetails.amountCrypto + ' ' + this.setCurrencyCode();
      this.confirmedResponse.address = response.data.paymentAddress;
      this.confirmedResponse.quoteId = this.quoteId;
      this.loadingDelivery = false;
      this.goToQrCodePage();
    } else {
      this.loadingDelivery = false;
    }
  }

  goToQrCodePage() {
    this.disableDeliveryBtn = false;
    this.nav.navigateForward(['/buy-assets/qr-code-page'], { queryParams: { confirmedResponse: JSON.stringify(this.confirmedResponse) } });
  }

  reset() {
    this.nav.navigateBack(['/buy-assets', this.reviewOrderDetails.asset], {
      queryParams: {
        form: JSON.stringify(
          {
            payWithDisplay: this.reviewOrderDetails.payWithDisplay,
            payWith: this.reviewOrderDetails.payWith
          }
        ), promo: null
      }
    });
  }
 
  async paymentRequest() {
    let result: any;
    console.log('=========== here payment request ==================')
    try {
      result = await this.creditDebitCardService.postPaymentRequest( 
        this.reviewOrderDetails.quoteId,
        this.walletAddress,
        this.reviewOrderDetails.currencyCode
      );
      if (result.error && result.error.length > 0) {
        await presentToast('Failed', result.error, this.translate, this.toast, this.platform, true);
        this.loadingDelivery = false;
        this.disableDeliveryBtn = false;
        return;
      }
      Logger.info('ReviewOrderComponent paymentRequest', result);
      console.log({ payment_id: result.payment_id })
      this.reviewOrderDetails.paymentId = result.payment_id;
      this.loadingDelivery = false;
      this.disableDeliveryBtn = false;
      await this.openPaymentConfirmationModal();
    } catch (error) {
      Logger.info('ReviewOrderComponent paymentRequest error', error);
    }
  }

  async openPaymentConfirmationModal() {
    let cssClass = '';
    cssClass += this.isDesktopMode ? 'success-modal-desktop' : 'success-modal';
    const modal = await this.modalController.create({
      component: SimplexPaymentConfirmationModalComponent,
      cssClass,
      initialBreakpoint: this.isDesktopMode ? undefined : 0.5,
      breakpoints: this.isDesktopMode ? undefined : [0, 0.5, 0.6],
      componentProps: {
        payment_id: this.reviewOrderDetails.paymentId,
      },
      backdropDismiss: false,
      id: 'payment-request-confirmation-modal',
    });
    await modal.present();
    await modal.onDidDismiss().then((res) => {
      if (res.data) {
        this.opensimplex();
      }
    });
  }
  async opensimplex() {
    let cssClass = '';
    cssClass += this.isDesktopMode ? 'simplex-widget-modal-desktop' : 'simplex-widget-modal';
    const modal = await this.modalController.create({
      component: SimplexCheckoutModalComponent,
      cssClass,
      componentProps: {
        payment_id: this.reviewOrderDetails.paymentId,
      },
      backdropDismiss: false,
      id: 'simplex-checkout-modal',
    });
    await modal.present();
    await modal.onDidDismiss().then((res) => {
      Logger.info(res);
      if (res.data) {
        this.goToSuccess();
      }
      this.loadingDelivery = false;
      this.disableDeliveryBtn = false;
    });
  }
}
